exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lT1WRrR2W3-mCmf_vU4nz{height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%}.lT1WRrR2W3-mCmf_vU4nz:before{background:-webkit-gradient(linear,left top,left bottom,from(#000),to(transparent));background:-webkit-linear-gradient(top,#000,transparent);background:linear-gradient(180deg,#000 0,transparent);content:\"\";height:100px;left:0;position:absolute;top:0;width:100%}", ""]);

// exports
exports.locals = {
	"animatedBackground": "lT1WRrR2W3-mCmf_vU4nz"
};